var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterFbIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_532_975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.32996 0C3.91172 0 0.329956 3.58176 0.329956 8C0.329956 11.7517 2.913 14.8998 6.39748 15.7645V10.4448H4.74788V8H6.39748V6.94656C6.39748 4.22368 7.6298 2.9616 10.3031 2.9616C10.81 2.9616 11.6845 3.06112 12.0423 3.16032V5.37632C11.8535 5.35648 11.5255 5.34656 11.1181 5.34656C9.80644 5.34656 9.29956 5.84352 9.29956 7.13536V8H11.9127L11.4637 10.4448H9.29956V15.9414C13.2608 15.463 16.3303 12.0902 16.3303 8C16.33 3.58176 12.7482 0 8.32996 0Z",
    fill: "#7F9AA6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_532_975"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.329956)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterFbIcon);
export default __webpack_public_path__ + "static/media/footer-fb-icon.406e3858a432ab0c58547d18c46806f9.svg";
export { ForwardRef as ReactComponent };